module.exports = __webpack_public_path__ + "static/media/cheese.05d19b31.jpg";